import { TYPE } from "@gaoya/shared";
import { C, drawPanel, fillRound } from "../theme.js";
import { settingsPanel } from "../../ui/hall.js";
import type { UiState } from "../../game/state.js";

export function drawScrim(ctx: CanvasRenderingContext2D, w: number, h: number, a = 0.5): void {
  ctx.fillStyle = `rgba(30,24,20,${a})`;
  ctx.fillRect(0, 0, w, h);
}

export function drawSwitch(ctx: CanvasRenderingContext2D, x: number, y: number, on: boolean): void {
  const sw = 48;
  const sh = 28;
  fillRound(ctx, x, y, sw, sh, sh / 2, on ? C.seal : "#D9CDBA");
  const kx = on ? x + sw - sh + 3 : x + 3;
  fillRound(ctx, kx, y + 3, sh - 6, sh - 6, (sh - 6) / 2, "#FFFFFF");
}

export function drawSettings(ctx: CanvasRenderingContext2D, ui: UiState, w: number, h: number): void {
  drawScrim(ctx, w, h);
  const g = settingsPanel(w, h);
  drawPanel(ctx, g.x, g.y, g.w, g.h, 20, C.card, null, null);
  ctx.fillStyle = C.ink;
  ctx.font = `700 21px ${TYPE.serif}`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("茶馆规矩", w / 2, g.y + 34);
  ctx.fillStyle = C.ink2;
  ctx.font = `12px ${TYPE.sans}`;
  ctx.fillText("音效、触感与隐私，随时可改", w / 2, g.y + 58);
  const rows: [string, string, boolean | "link"][] = [
    ["琴音", "背景音乐", !ui.bgmMuted],
    ["击键与战鼓", "按键与对局音效", !ui.sfxMuted],
    ["触控轻震", "点击时轻微震动", !ui.vibrateMuted],
    ["隐私保护指引", "了解信息如何被使用", "link"],
  ];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    if (!row) continue;
    const ry = g.y + 84 + i * 56;
    const rx = g.x + 16;
    const rw = g.w - 32;
    fillRound(ctx, rx, ry, rw, 48, 12, C.cardSoft);
    ctx.textAlign = "left";
    ctx.fillStyle = C.ink;
    ctx.font = `600 15px ${TYPE.sans}`;
    ctx.fillText(row[0], rx + 14, ry + 16);
    ctx.fillStyle = C.ink3;
    ctx.font = `11px ${TYPE.sans}`;
    ctx.fillText(row[1], rx + 14, ry + 34);
    if (row[2] === "link") {
      ctx.fillStyle = C.seal;
      ctx.font = `600 13px ${TYPE.sans}`;
      ctx.textAlign = "right";
      ctx.fillText("查看  ›", rx + rw - 14, ry + 24);
      continue;
    }
    drawSwitch(ctx, rx + rw - 14 - 48, ry + 10, row[2]);
  }
}
